export default __webpack_public_path__ + "static/media/dalen3big.2004f194.jpg";